import { createSelector } from 'reselect'

import { userName } from '@/core/selectors/currentUser'
import { companyName } from '@/core/selectors/company'
import { urlParams } from '@/core/selectors/router'
import { getDefaultMessageTemplate, processTemplate, templateVariablesBuilder } from '@/core/helpers/positions'
import { showTemplateToMember } from './members'

const getCandidate = state => state.views.candidateDetails_LEGACY.candidate.member

const selectedPositionId = state => state.views.candidateDetails_LEGACY.interviewRequest.selectedIrPositionId
export const getPositions = state => state.views.candidateDetails_LEGACY.positions.collection

const positionFromListId = state => state.views.candidateList_LEGACY.positions.fromList.id
export const selectedPositionFromListId = createSelector([urlParams, positionFromListId], (urlParams, positionFromListId) => {
  if (urlParams.pid) return urlParams.pid

  return positionFromListId || null
})

export const positionsDropdown = createSelector([getPositions, selectedPositionId], (positions, selectedPositionId) =>
  positions.map(position => ({
    ...position,
    selected: selectedPositionId ? selectedPositionId.id === position.id : false,
  })),
)

export const selectedPosition = createSelector([getPositions, selectedPositionId], (positions, selectedPositionId) => {
  if (!positions || !positions.length || !selectedPositionId) return

  const position = positions.find(position => position.id === selectedPositionId)

  return position
})

export const interviewRequestTemplate = createSelector(
  [userName, getCandidate, companyName, showTemplateToMember, selectedPosition],
  (currentUserName, candidate, companyName, showFirstMessageTemplate, position) => {
    const candidateName = candidate.name.split(' ')[0]
    const senderName = currentUserName.split(' ')[0]

    if (position && position.message_template && position.message_template.trim()) {
      const templateVariables = templateVariablesBuilder(candidateName, senderName, companyName, position.name)

      return processTemplate(position.message_template, templateVariables)
    }

    if (showFirstMessageTemplate) {
      const templateVariables = templateVariablesBuilder(candidateName, senderName, companyName, '')

      return processTemplate(getDefaultMessageTemplate(), templateVariables)
    }

    return `Hi ${candidateName}, `
  },
)
